import React from "react";

export default function manageFields(fields, selector = () => ({})) {
  return Component =>
    class extends React.Component {
      state = fields;

      updateField = field => val => this.setState({ [field]: val });
      toggleField = field => () =>
        this.setState(state => ({ [field]: !state[field] }));

      render() {
        const props = {
          ...this.props,
          ...this.state,
          updateField: this.updateField,
          toggleField: this.toggleField
        };

        return <Component {...props} {...selector(props)} />;
      }
    };
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/manageFields.jsx